export const directoryLogoPath: string = '/Blob/images/brands'
export const defaultLogoPath: string = `${directoryLogoPath}/ampol.webp`
export const mapBrands: Map<string, string> = new Map([
    ['ampol', 'webp'],
    ['ampol-group', 'webp'],
    ['boost-juice', 'webp'],
    ['hungry-jacks', 'webp'],
    ['noodle-box', 'webp'],
    ['retail-store', 'webp'],
    ['z-energy', 'webp'],
    ['z-energy-retail', 'webp'],
])